import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.premierCancellations');

  return (
    <View>
      <Gutter style={styles.base}>
        <Text variant="subheading" emphasis="low" style={styles.label}>
          {tt('label.cancellationDate', 'Cancellation Date')}
        </Text>
        <View style={styles.value}>
          <LoadingBox
            style={styles.loadingBoxCancellationDate}
            testID="loading-box-name"
          />
        </View>
      </Gutter>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {tt('title', 'Order History')}
        </Text>
      </Gutter>
      <View style={styles.order}>
        <View style={styles.orderLine1}>
          <View style={styles.orderDate}>
            <LoadingBox
              style={styles.loadingBoxOrderDate}
              testID="loading-box-name"
            />
            <LoadingBox
              style={styles.loadingBoxOrderNumber}
              testID="loading-box-name"
            />
          </View>
          <View style={styles.orderAmount}>
            <LoadingBox
              style={styles.loadingBoxOrderTotal}
              testID="loading-box-name"
            />
          </View>
        </View>
      </View>
    </View>
  );
};
